import { exists } from './exists'

/**
 * 検査対象が存在する場合は変換関数を適用し、存在しない場合は undefined を返します。
 *
 * @template T - 検査対象の型。
 * @template U - 変換後の型。
 * @param value - 検査対象。
 * @param fn - 変換関数。
 * @returns 変換後の値。
 */
export function applyIfExist<T, U>(
  value: T | null | undefined,
  fn: (value: T) => U,
): U | undefined

/**
 * 検査対象が存在する場合は変換関数を適用し、存在しない場合は undefined を返します。
 *
 * @template T - 検査対象の型。
 * @template U - 変換後の型。
 * @param fn - 変換関数。
 * @returns 検査対象を引数に取り、変換後の値を返す関数。
 */
export function applyIfExist<T, U>(
  fn: (value: T) => U,
): (value: T | null | undefined) => U | undefined

/**
 * @param args - 引数。
 * @returns 結果または部分適用された関数。
 */
export function applyIfExist<T, U>(
  ...args: [(value: T) => U] | [T | null | undefined, (value: T) => U]
): U | ((value: T | null | undefined) => U | undefined) | undefined {
  const applyIfExistInner = (
    value: T | null | undefined,
    fn: (value: T) => U,
  ): U | undefined => (exists(value) ? fn(value) : undefined)

  if (args.length === 1) {
    return (value: T | null | undefined): U | undefined =>
      applyIfExistInner(value, ...args)
  }

  return applyIfExistInner(...args)
}
